module.exports = __webpack_public_path__ + "static/media/galerija_2021 (12)-min.1a33b3d2.jpg";